import { useMemo } from 'react';

import { useLibraryCollectionLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useGetCollectionTitle = () => {
  const [query, queryResult] = useLibraryCollectionLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const loading = queryResult?.loading;
  const collectionData = queryResult?.data?.result ?? undefined;

  const request = (collectionId: string, companyId: string) => {
    query({
      variables: {
        collectionId,
        companyId,
      },
    });
  };

  return useMemo(
    () => ({
      request,
      loading,
      title: collectionData?.title,
    }),
    [loading, collectionData?.title]
  );
};

export default useGetCollectionTitle;
